import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { recarregarQuandoTrocar } from './atualizar'
import './styles/tokens.css'

// Um erro consertado ontem não adianta nada se o celular dela continuar com o
// código de anteontem. Quando o service worker novo assume, a página recarrega.
recarregarQuandoTrocar()

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html')

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
